
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import FrontDashboardApi from "@/api/front-dashboard-api";
import { Toast } from "vant";
type CurrencyType = "USD" | "HKD"
type IQueryType = {
    currency: CurrencyType, amount: number, exchange: number, weight: number, tariff: number, agent: number, vat: number, lowAgent: number
/**运保杂 */ fii: number
}
type IResult = { goodsRmb: number, tariffRmb: number, vatRmb: number, agentRmb: number, weightRmb: number }

@Component({ name: "CustomsFee" })
export default class FeeCalc extends Vue {
    query: IQueryType = {} as any
    requestFields: Record<keyof IQueryType, boolean> = { amount: false, exchange: false, weight: false, tariff: false, agent: false, vat: false } as any
    currencyOptions = [{ text: "USD", value: "USD" }, { text: "HKD", value: "HKD" }]
    reuslt: IResult | null = null
    totalAmount = { agent: 0, weight: 0 }
    exchangeRate: FrontDashboardApi.IExchangeRateLastResult = { USD: 7.1234, HKD: 0.9256 } as any

    get isDouble() {
        if (!this.reuslt) return false;
        return (this.reuslt.agentRmb && this.reuslt.weightRmb);
    }
    get differenceAmount() {
        if (!this.isDouble) return 0;
        return Math.abs(this.totalAmount.agent - this.totalAmount.weight)
    }

    created() { }
    mounted() {
        FrontDashboardApi.getCustomsRate().then(e => {
            this.exchangeRate = e
            this.currencyOnChange(this.query.currency);
        })
        this.clear();
    }

    focusAction(field: keyof IQueryType, isOut?: boolean) {
        if (!isOut) {
            this.requestFields[field] = false
            return;
        }
        const value = this.query[field];
        this.requestFields[field] = !value;
    }

    @Watch("query.currency")
    currencyOnChange(v: CurrencyType) {
        var r = this.exchangeRate[v];
        if (r) {
            this.query.exchange = r;
            return;
        }
    }
    checkFrm() {
        if (!this.query.amount) return "请输入“报关货值”"
        if (!this.query.exchange) return "请输入“汇率”"
        if (!this.query.weight && !this.query.agent) return "“货物重量”和“代理费率”不能同时为0"
        return undefined
    }

    async calc() {

        const err = this.checkFrm();
        if (err) return Toast.fail(err);

        const goodsRmb = (Number(this.query.amount) || 0) * this.query.exchange
        const goodsWithFii = goodsRmb * this.query.fii / 100 + goodsRmb;
        const tariffRmb = goodsWithFii * (Number(this.query.tariff) || 0) / 100;
        const vatRmb = (goodsWithFii + tariffRmb) * (Number(this.query.vat) || 0) / 100;
        const agentRmb = !this.query.agent ? 0 : Math.max(this.query.lowAgent, (goodsWithFii + tariffRmb + vatRmb) * (Number(this.query.agent) || 0) / 100);

        const w = Number(this.query.weight) || 0
        const weightRmb = w ? Math.max((w * 5.8), 5.8) : 0;
        this.reuslt = { goodsRmb, tariffRmb, vatRmb, agentRmb, weightRmb }
        const baseRmb = goodsRmb + tariffRmb + vatRmb;
        this.totalAmount = { weight: baseRmb + weightRmb + 150, agent: baseRmb + agentRmb }
        await this.$nextTick()
        const el = this.$refs["result"] as HTMLElement
        el.scrollIntoView(true);
    }

    clear() {
        this.reuslt = null;
        this.query = {
            currency: "USD", amount: undefined as any, exchange: 7.1234 as any,
            weight: undefined as any, tariff: 0, agent: 0.25, vat: 13, fii: 0.145,
            lowAgent: 300
        }
        const el = document.getElementsByClassName("my-layout-appMain")
        if (!el.length) return;
        el[0].scrollIntoView(true);
    }
}
